export default function Logo({ dark = false }) {
  if (!dark) {
    return (
      <a href="#inicio" data-testid="logo-link" className="flex items-center group">
        <img
          src="/brand/logo-horizontal.png"
          alt="WYD personal travelling"
          className="h-9 w-auto transition-transform duration-300 group-hover:scale-[1.03]"
        />
      </a>
    );
  }
  return (
    <a href="#inicio" data-testid="logo-link" className="flex items-center gap-2.5 group">
      <img
        src="/brand/logo-emblem.png"
        alt="WYD"
        className="h-10 w-auto shrink-0 transition-transform duration-300 group-hover:scale-[1.06]"
      />
      <span className="leading-none">
        <span className="font-display font-semibold text-xl tracking-wide text-[#FAF6EE]">
          WYD
        </span>
        <span className="block text-[9px] font-semibold uppercase tracking-[0.28em] mt-0.5 text-[#D9A854]">
          personal travelling
        </span>
      </span>
    </a>
  );
}
